import React, { useState } from 'react';
import {
  IonContent,
  IonPage,
  IonList,
  IonButton,
  IonToast,
  IonLabel,
  IonIcon
} from '@ionic/react';
import { logoGoogle, logoFacebook } from 'ionicons/icons';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/userActions';
import '@codetrix-studio/capacitor-google-auth';
import { Plugins } from '@capacitor/core';
// import _ from 'lodash';

import { loginUser, loginGoogleUser, registerUser } from '../firebaseConfig';

const Login: React.FC = (props: any) => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [cpassword, setCpassword] = useState<string>('');

  const [newUser, setNewUser] = useState<boolean>(false);
  const [working, setWorking] = useState<boolean>(false);

  if (localStorage.getItem('user') && !props.user) {
    props.onSetUser({ email: localStorage.getItem('user') });
  }

  //handle toast
  const [showToast, setShowToast] = useState(false);

  async function login() {
    setWorking(true);
    if (!email || email.length < 5 || !password) {
      popToast();
      return;
    }
    const res = await loginUser(email, password);
    if (res) {
      props.onSetUser({ email: res });
      localStorage.setItem('user', res);
    } else {
      popToast();
    }
  }

  async function loginWithGoogle() {
    setWorking(true);
    const res = await Plugins.GoogleAuth.signIn();
    console.log(res);
    if (res.email) {
      props.onSetUser({ email: res.email });
      localStorage.setItem('user', res.email);
    } else {
      popToast();
    }
  }

  async function register() {
    setWorking(true);
    if (email && email.length > 5 && password && password === cpassword) {
      const res = await registerUser(email, password);
      if (res) {
        props.onSetUser({ email: res });
        localStorage.setItem('user', res);
      }
    } else {
      popToast();
    }
  }

  function popToast() {
    setWorking(false);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  }

  return (
    <IonPage>
      <IonContent>
        <IonList>
          <img
            src="assets/mosi.png"
            alt="logo"
            className="centered"
            style={{
              width: 250,
              marginTop: '10vh',
              display: 'block',
            }}
          />
          <img
            src="assets/shopping_app.svg"
            alt="data illustration"
            className="centered"
            style={{
              width: 250,
              display: 'block',
            }}
          />        
          <IonButton expand="block" color="dark" onClick={loginWithGoogle}>
            <IonIcon icon={logoGoogle} />
            <IonLabel class="ion-padding">Login with Google</IonLabel>
          </IonButton>
          <IonButton expand="block" color="dark" onClick={()=>{}}>
            <IonIcon icon={logoFacebook} />
            <IonLabel class="ion-padding">Login with Facebook</IonLabel>
          </IonButton>
        </IonList>
      </IonContent>

      <IonToast
        isOpen={showToast}
        message="Login Failed"
        duration={3000}
        position="bottom"
      />
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onSetUser: (payload: {}) => dispatch(actionCreator.setUser(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
